import React from 'react';
import './Integrations.css';

import integrationsDiagram from '../Images/Website integrations diagram.png'
// Import available logos
import amazonLogo from '../Logos/amazon.png';
import axwayLogo from '../Logos/axway.png';
import btradeLogo from '../Logos/btrade.png';
import cddateLogo from '../Logos/cddate.png';
import cerberusLogo from '../Logos/cerberus-logo-light.png';
import cleoLogo from '../Logos/cleo.png';
import couchdropLogo from '../Logos/Couchdrop_Logo_RGB_v2.png';
import coviantLogo from '../Logos/coviant-menu-logo.png';
import filesComLogo from '../Logos/files com.png';
import fortraLogo from '../Logos/fortra.png';
import hulftLogo from '../Logos/hulft.png';
import ibmLogo from '../Logos/IBM.png';
import jscapeLogo from '../Logos/jscape.png';
import kiteworksLogo from '../Logos/kiteworks-logo-1.png';
import metadefenderLogo from '../Logos/metadefender.png';
import opentextLogo from '../Logos/opentext.png';
import primeurLogo from '../Logos/Primeur - Logo.png';
import seeburgerLogo from '../Logos/SEEBURGER_logo.png';
import sftpCloudLogo from '../Logos/sftp cloud.png';
import sftpPlusLogo from '../Logos/sftpplus-ua.png';
import stonebranchLogo from '../Logos/stonebranch.png';
import tectiaLogo from '../Logos/tectia.png';
import thruLogo from '../Logos/thru.png';
import tibcoLogo from '../Logos/tibco-header-logo.png';
import progressLogo from '../Logos/Progress.png';
import servuLogo from '../Logos/servu.png';
import filezillaLogo from '../Logos/filezilla.png';

// Helper to resolve logo or fallback to SVG asset
const getLogo = (name) => {
    switch (name.toLowerCase()) {
        case 'aws transfer family':
        case 'amazon':
            return amazonLogo;
        case 'axway':
            return axwayLogo;
        case 'btrade':
            return btradeLogo;
        case 'cdata':
            return cddateLogo;
        case 'cerberus':
            return cerberusLogo;
        case 'cleo':
            return cleoLogo;
        case 'couchdrop':
            return couchdropLogo;
        case 'coviant':
            return coviantLogo;
        case 'files.com':
        case 'files com':
            return filesComLogo;
        case 'fortra':
        case 'fortra ga & eft':
            return fortraLogo;
        case 'hulft':
            return hulftLogo;
        case 'ibm sterling':
        case 'ibm':
            return ibmLogo;
        case 'jscape':
            return jscapeLogo;
        case 'kiteworks':
            return kiteworksLogo;
        case 'metadefender':
            return metadefenderLogo;
        case 'opentext':
            return opentextLogo;
        case 'primeur':
            return primeurLogo;
        case 'seeburger':
            return seeburgerLogo;
        case 'sftpcloud':
        case 'sftp cloud':
            return sftpCloudLogo;
        case 'sftplus':
        case 'sftpplus':
            return sftpPlusLogo;
        case 'stonebranch':
            return stonebranchLogo;
        case 'tectia':
            return tectiaLogo;
        case 'thru':
            return thruLogo;
        case 'tibco':
        case 'tibco header logo':
            return tibcoLogo;
        case 'ws_ftp':
        case 'moveit':
            return progressLogo;
        case 'securetransport':
            return axwayLogo;
        case 'serv-u':
            return servuLogo;
        case 'filezilla server':
            return filezillaLogo;
        default:
            return `/assets/logos/${name.toLowerCase().replace(/\s+/g, '-')}.svg`;
    }
};

const integrations = [
    {
        category: 'Managed File Transfer (MFT)',
        items: [
            'JScape', 'SecureTransport', 'Fortra GA & EFT', 'MOVEit',
            'Cleo', 'CData', 'Kiteworks', 'Primeur', 'bTrade', 'Thru',
            'Coviant', 'HulFT', 'Stonebranch', 'TIBCO', 'SFTPlus',
            'AWS Transfer Family', 'MetaDefender', 'OpenText'
        ],
    },
    {
        category: 'Electronic Data Interchange (EDI)',
        items: ['IBM Sterling', 'CData', 'Cleo', 'Seeburger'],
    },
    {
        category: 'File Transfer (FT)',
        items: [
            'Serv-U', 'WS_FTP', 'Tectia', 'Files.com',
            'Couchdrop', 'Cerberus', 'Filezilla Server', 'SFTPCloud'
        ],
    },
    {
        category: 'EAI (Enterprise Application Integration)',
        items: ['Cleo', 'CData', 'Stonebranch'],
    },
];

const Integrations = () => (
    <div className="container integrations-page">
        {/* Top Diagram Placeholder */}

        <div className="intro-text">
            <h2 className="page-title">Monitor Anything with an<br/> FTPS, SFTP or HTTPS Interface</h2>
            <p className="section-description">
                Whether it be MFT, EDI, a simple file transfer tool or something else.<br/> We are protocol-centric and
                can connect to anything
                with an FTPS, SFTP or HTTPS interface.
            </p>
        </div>
        <div className="integration-diagram">
            <img src={integrationsDiagram} alt="Integrations architecture diagram"/>
        </div>

        <div className="integrations-grid">
            {integrations.map(({category, items}) => (
                <div key={category} className="integration-category">
                    <h3 className="category-title">{category}</h3>
                    <div className="logo-grid">
                        {items.map(name => (
                            <div key={name} className="logo-item">
                                <img
                                    src={getLogo(name)}
                                    alt={name}
                                    className="logo"
                                />
                                <span className="logo-label">{name}</span>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    </div>
);

export default Integrations;
